import component from './SearchConstructor.vue'
export default component
